import { CALL_DATA } from "../../constants/PublicVariables";
import useLanguageChange from "../../hooks/useLanguageChange";
import { showGridView } from "./GalleryViewUtils";

const ReturnToGalleryViewButton = () => {
    const localisedValues = useLanguageChange();

    const handleReturnToGalleryViewButton = () => {
        showGridView(CALL_DATA.localIdentity, true);
    };

    return (
        <div className='video-collapse-button'>
            <button className='btn' onClick={handleReturnToGalleryViewButton}>
                <span className='for-icon icon-collapse-video'></span>
                <span className='for-text'>{localisedValues?.return_to_gallery_view}</span>
            </button>
        </div>
    );
};

export default ReturnToGalleryViewButton;
